var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.828,
    height: 14.829
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 747",
    d: "M1.414 1.414l6 6-6 6",
    fill: "none",
    stroke: "#000"
  }))));
}
export default SvgChevronNext;